export const specialities = [
  'Allergy & Immunology',
  'Anesthesiology',
  'Dermatology',
  'Emergency Medicine',
  'Family Medicine',
  'Internal Medicine',
  'Medical Genetics',
  'Neurological Surgery',
  'Nuclear Medicine',
  'Obstetrics & Gynecology',
  'Oncology',
  'Otolaryngology',
  'Pathology-Anatomic & Clinical',
  'Pediatrics',
  'Physical Medicine & Rehabilitation',
  'Preventive Medicine',
  'Psychiatry',
  'Radiology-Diagnostic',
  'Sleep Medicine',
  'Surgery-General',
  'Thoracic Surgery',
  'Urology',
]

export const subSpecialities = [
  'Clinical & Laboratory Immunology',
  'Adult Cardiothoracic Anesthesiology',
  'Critical Care Medicine',
  'Obstetric Anesthesiology',
  'Pain Medicine',
  'Pediatric Anesthesiology',
  'Procedural Dermatology',
  'Dermatopathology',
  'Medical Toxicology',
  'Pediatric Emergency Medicine',
  'Sports Medicine',
  'Geriatric Medicine',
  'Advanced Heart Failure & Transplant Cardiology',
  'Cardiovascular Disease',
  'Clinical Cardiac Electrophysiology',
  'Endocrinology, Diabetes & Metabolism',
  'Gastroenterology',
  // 'Geriatric Medicine',
  'Hematology',
  'Hematology & Oncology',
  'Infectious Disease',
  'Internal Medicine - Pediatrics',
  'Interventional Cardiology',
  'Nephrology',
  'Pulmonary Disease',
  'Pulmonary Disease & Critical Care Medicine',
  'Rheumatology',
  'Transplant Hepatology',
  'Biochemical Genetics',
  'Molecular Genetic Pathology',
  'Endovascular Surgical Neuroradiology',
  'Child Neurology',
  'Clinical Neurophysiology',
  'Neuromuscular Medicine',
  'Female Pelvic Medicine & Reconstructive Surgery',
  'Radiation Oncology',
  'Ophthalmic Plastic & Reconstructive Surgery',
  'Adult Reconstructive Orthopaedics',
  'Foot & Ankle Orthopaedics',
  'Hand Surgery',
  'Musculoskeletal Oncology',
  'Orthopaedic Surgery of the Spine',
  'Orthopaedic Trauma',
  'Pediatric Orthopaedics',
  'Otology - Neurotology',
  'Pediatric Otolaryngology',
  'Blood Banking - Transfusion Medicine',
  'Chemical Pathology',
  'Cytopathology',
  'Forensic Pathology',
  'Medical Microbiology',
  'Neuropathology',
  'Pediatric Pathology',
  'Adolescent Medicine',
  'Child Abuse Pediatrics',
  'Developmental-Behavioral Pediatrics',
  'Neonatal-Perinatal Medicine',
  'Pediatric Cardiology',
  'Pediatric Critical Care Medicine',
  'Pediatric Endocrinology',
  'Pediatric Gastroenterology',
  'Pediatric Hematology-Oncology',
  'Pediatric Infectious Diseases',
  'Pediatric Nephrology',
  'Pediatric Pulmonology',
  'Pediatric Rheumatology',
  'Pediatric Sports Medicine',
  'Pediatric Transplant Hepatology',
  'Spinal Cord Injury Medicine',
  'Craniofacial Surgery',
  'Addiction Psychiatry',
  'Child & Adolescent Psychiatry',
  'Forensic Psychiatry',
  // 'Geriatric Psychiatry',
  'Abdominal Radiology',
  'Cardiothoracic Radiology',
  'Muscoskeletal Radiology',
  'Neuroradiology',
  'Nuclear Radiology',
  'Pediatric Radiology',
  'Vascular & Interventional Radiology',
  'Pediatric Surgery',
  'Surgical Critical Care',
  'Vascular Surgery',
  'Congenital Cardiac Surgery',
  'Pediatric Urology',
]

export const mockSpecialities = [...specialities, ...subSpecialities]
